import React from 'react';
import {
  Table, Dropdown,
} from 'semantic-ui-react';
import { PENDING_VRA_NOTES_ACTION, PENDING_VRA_NOTES_ACTION_LABEL } from '../../constants/pendingVraNotes';

// canEdit: the user is a pending_vra_editor. A viewer sees Edit, Allow and Invalidate greyed out and can still open the details.
const VRAPendingRow = (actionHandler, canEdit = true) => vraPending => {
  if (!vraPending) return null;

  const rowMenuOptions = [
    { key: 1, text: 'Edit', value: 'edit', disabled: !canEdit },
    { key: 2, text: 'View Detail', value: 'view' },
    { key: 5, text: PENDING_VRA_NOTES_ACTION_LABEL, value: PENDING_VRA_NOTES_ACTION },
  ];
  const handleActionChange = (e, { value }) => {
    e.preventDefault();
    actionHandler(value, vraPending);
  };
  const id = vraPending?.id;
  const status = vraPending?.status;
  const returnInitiatedAt = vraPending?.returnInitiatedAt;
  const expirationDate = vraPending?.expirationDate;
  const purchasePrice = vraPending?.transaction?.purchasePrice;
  const username = vraPending?.returningUser?.username;
  const dealerName = vraPending?.guaranteePurchase?.guaranteeOffer?.dealerName;
  const vin = vraPending?.guaranteePurchase?.guaranteeOffer?.vehicleInformation?.vin;
  const dealerNumber = vraPending?.guaranteePurchase?.guaranteeOffer?.auctionInformation?.dealerNumber;
  const name = vraPending?.auctionLocation?.name;
  const pendingReasons = vraPending?.pendingReasons ?? [];
  return (
    <Table.Row key={id}>
      <Table.Cell>{id}</Table.Cell>
      <Table.Cell>{vin}</Table.Cell>
      <Table.Cell>{dealerNumber}</Table.Cell>
      <Table.Cell>{dealerName}</Table.Cell>
      <Table.Cell>{name}</Table.Cell>
      <Table.Cell>{status}</Table.Cell>
      <Table.Cell>{purchasePrice}</Table.Cell>
      <Table.Cell>{returnInitiatedAt}</Table.Cell>
      <Table.Cell>{expirationDate}</Table.Cell>
      <Table.Cell>{pendingReasons.length === 0 ? '' : pendingReasons.map(pendingReason => pendingReason.notice).join(', ')}</Table.Cell>
      <Table.Cell>{username}</Table.Cell>
      <Table.Cell>
        <Dropdown
          text='Actions'
          options={rowMenuOptions}
          icon='ellipsis horizontal'
          onChange={handleActionChange}
          inline
          item
          selectOnBlur={false}
          value={null}
        />
      </Table.Cell>
    </Table.Row>
  );
};

export default VRAPendingRow;
